<template>
        
	<app-content class="h-panel">
		
		<div class="h-panel-body padding font-bold">
            <div class="h-panel-bar">
                <span class="h-panel-title">常用摘要</span>
            </div>
			<div class="pull-right">
				<Button @click="create()"   color="primary">新增分类</Button>
			</div>
            </div>
		</div>
		<div class="h-panel-body padding">
			<Table :datas="datas" border :loading="loading" >
				<TableItem title="编码">
					<template slot-scope="{data}">
						<span :style="{paddingLeft:(data.isRoot?1:2)*15+'px'}">{{data.code}}</span>
					</template>
				</TableItem>
				<TableItem title="名称" prop="name"></TableItem>
				<TableItem title="助记码" prop="easyCode"></TableItem>
				<!-- <TableItem title="状态" align="center" :width="100">
					<template slot-scope="{data}">
						{{data.status?"正常":"不可用"}}
					</template>
				</TableItem> -->
				<TableItem title="操作" :width="150" align="center">
					<div class="actions" slot-scope="{data}">
						<span @click="create(data)" v-if="data.isRoot == 1 ">新增下级</span>
						<span @click="edit(data)">编辑</span>
						<span @click="remove(data)">删除</span>
					</div>
				</TableItem>
			</Table>
		</div>
		<Modal v-model="showForm" type="drawer-right" hasCloseIcon>
			<div slot="header">新增摘要</div>
			<Form :readonly="used" ref="form" v-width="800" mode="twocolumn" :labelWidth="150" :model="form" :rules="validationRules">
				<img v-if="used" class="used" src="@/assets/used.png" alt="已使用">
				<FormItem label="摘要编码" prop="code">
					<div class="h-input-group" v-if="!form.id && parent">
						<!-- <span class="h-input-addon bg-white-color" style="padding-right: 0;border-right: none;line-height: 32px;;color: #001529;">{{parent.code}}</span> -->
						<input style="padding-left: 0;border-left: none;" type="text" v-model="form.code" :maxlength="6">
					</div>
					<input v-else-if="!form.id && !parent" type="text" v-model="form.code" :maxlength="4">
					<input v-else type="text" v-model="form.code" disabled>
				</FormItem>
				<FormItem label="摘要名称" prop="name">
					<input type="text" v-model="form.name" :disabled="form.systemDefault || used">
				</FormItem>
                <FormItem label="摘要分类">
					<input type="text" :value="parentAbstract" disabled>
				</FormItem>  
                <FormItem label="助记码" prop="easyCode">
					<input type="text" v-model="form.easyCode" disabled />
				</FormItem>
				 
			</Form>
			<div class="text-center">
				<Button color="green" @click="submit" :disabled="used" :loading="loading">{{form.id?'保存':'保存'}}</Button>
				<Button @click="showForm=false">取消</Button>
			</div>
		</Modal>
	</app-content>
</template>

<script>

	import Pinyin from 'chinese-to-pinyin'
	import StringUtils from 'string-utilz'
	import {mapState} from 'vuex';

	const emptyForm = {
        "id":undefined,
		"code": "",
		"name": "",
		"easyCode": "",
        "isRoot":undefined,
        "accountSetsId":undefined, 
        "parentId":0
	};

	export default {
		name: "Subject",
		data() {
			return {
                accountSetsId: 0,
				codeLen: [4, 2, 2, 2],
				lenData: [2, 3, 4],
				lenData2: [1, 2, 3, 4],
				tabDatas: [{
					title: '资产',
					key: 'CodeAssets'
				}, {
					title: '负债',
					key: 'CodeLiabilities'
				}, {
					title: '权益',
					key: 'CodeInterest'
				}, {
					title: '成本',
					key: 'CodeCost'
				}, {
					title: '损益',
					key: 'CodeLoss'
				}],
				datas: [],
				accountingCategory: [],
				auxiliaryAccounting: [],
				unit: '',
				validationRules: {
					required: ["code", "name"]
				},
				parent: {},
				len: 2,  
				form: HeyUtils.copy(emptyForm),
				showForm: false,
				used: false,
				type: "资产",
				selected: 'CodeAssets',
				loading: false
			};
		},
		computed: { 
            ...mapState(['User', 'currentAccountSets']),
            
			parentAbstract() {
				return this.parent ? this.parent.name : '';
			}, 
		},
		watch: {
			type() {
				this.loadList()
			},
			showForm(val) {
				if (!val) {
					this.parent = null; 
					this.form = HeyUtils.copy(emptyForm); 
				}
			}, 
		},
		methods: { 
			 
			toPy() {
				let pyArr = [];
				this.form.name.split("").forEach(w => {
					w = w.trim();
					if (w) {
						if (/[\u4e00-\u9fa5]/.test(w)) {
							let py = Pinyin(w, {removeTone: true, keepRest: true}).trim();
							pyArr.push(py.substring(0, 1));
						} else {
							pyArr.push(w);
						}
					}
				});

				if (this.parent) {
					this.$set(this.form, 'easyCode',  pyArr.join(""));
					// if (!this.form.id) {
					// 	this.$set(this.form, 'code', this.parent.code + this.form.code);
                    //     console.log(this.form.code);
					// }
				} else {
					this.$set(this.form, 'easyCode', pyArr.join(""));
				}
			},
			loadList() {
				this.loading = true;
                
                var accountSetsId = this.User.accountSetsId;
                this.$api.cashier.abs_list(accountSetsId).then(({data}) => {
                    this.datas = data || [];
                    this.loading = false
                });
			},
			loadAccountingCategory() {
				this.$api.setting.accountingCategory.list().then(({data}) => {
					this.accountingCategory = data;
				});
			},
			submit() {
                this.form.accountSetsId = this.User.accountSetsId;
                if(this.form.parentId!=undefined && this.form.parentId>0){
                    this.form.isRoot=false;
                }else{
                    this.form.isRoot=true;
                } 
				let validResult = this.$refs.form.valid();
				if (validResult.result) {
					this.toPy(); 
					this.loading = true;

                    if(this.form.id==undefined||this.form.id==0){
                        this.$api.cashier.abs_add(this.form).then(data=>{
                            if(data.code==200){
                                this.showForm = false;
                                this.loadList();
                            }
                            this.loading = false; 
                        }).catch(() => {
                            this.loading = false;
                        });
                    }else{
                        this.$api.cashier.abs_edit(this.form).then(data=>{
                            
                            if(data.code==200){
                                this.showForm = false;
                                this.loadList();
                            }
                            this.loading = false;
                        }).catch(() => {
                            this.loading = false;
                        });
                    }

				// 	this.$api.setting.subject[this.form.id ? 'update' : 'save'](Object.assign(this.form)).then(() => {
				// 		this.loadList();
				// 		this.showForm = false;
				// 		this.loading = false;
				// 	}).catch(() => {
				// 		this.loading = false;
				// 	})
				}
			},
			create(data) { 
				this.parent = data;
				if (!data) {
					data = {level: 0, type: this.type, balanceDirection: '借'};
				}
				this.showForm = true;
				let children = this.datas.filter(value => value.parentId == data.id);
                if(children!=undefined && children.length>0){
                    let len = this.codeLen[data.isRoot?0:1];
                    this.len = len;
                    let start = "0";
                    if (children.length) {
                        let code = children[children.length - 1].code;
                        console.log('code:'+code)
                        start = (parseInt(code.substr(code.length - 2)) + 1) + "";
                    }
                    this.form.code =this.parent.code + StringUtils.pad(start, 0 - (2 - start.length), "0");
                }else{
                    this.form.code = this.parent.code +"01";
                }
				this.form.parentId = data.id;  
			},
			change(data) {
				this.type = data.title;
			},
			remove(data) {
				this.$Confirm("确认删除?").then(() => {
					this.$api.cashier.abs_del(data.id).then(() => {
						this.loadList();
					})
				})
			},
			edit(row) {
                this.parent = this.datas.find(value => value.id == row.parentId);
                this.form = Object.assign({}, row);
                this.showForm = true; 
			},
			doUpload() {
				this.$refs.file.click();
			},
			fileChange(e) {
				if (this.$refs.file.files.length) {
					let formData = new FormData();
					formData.append('file', this.$refs.file.files[0]);
					this.loading = true;
					this.$api.setting.subject.import(formData).then(({data}) => {
						this.$Message("亲,导入成功~");
						this.loadList();
					}).finally(() => {
						this.loading = false;
					});
					this.$refs.file.value = "";
				}
			}
		},
		mounted() {
			this.codeLen = this.currentAccountSets.encoding.split("-").map(value => parseInt(value));
			if (this.currentAccountSets.accountingStandards !== 0) {
				this.tabDatas = [{
					title: '资产',
					key: 'CodeAssets'
				}, {
					title: '负债',
					key: 'CodeLiabilities'
				}, {
					title: '共同',
					key: 'Common'
				}, {
					title: '权益',
					key: 'CodeInterest'
				}, {
					title: '成本',
					key: 'CodeCost'
				}, {
					title: '损益',
					key: 'CodeLoss'
				}];
			}
			this.loadList();
			this.loadAccountingCategory();
		}
	};
</script>

<style scoped>
	div.h-tabs.h-tabs-card {
		border-bottom: 1px solid #52abc50d;
	}

	div.h-panel-body {
		padding-top: 0px;
	}

	div.h-panel-bar {
		border-bottom: 0px solid #eeeeee;
		border-top: 1px solid #eeeeee;
	}

	.used {
		position: absolute;
		right: 50px;
		z-index: 10;
		top: 0;
	}
</style>
